import { useTranslation } from 'libs/i18n'
import { Badge } from 'shared/atoms'
import type { WithClassName } from 'shared/types/general.types'
import { cn } from 'utils/style'

type ActivityStatusProps = WithClassName<{
	status: boolean
	prefix?: string
	uppercase?: boolean
	dotSize?: 'sm' | 'md'
}>

export const ActivityStatus = ({
	status,
	prefix,
	uppercase = true,
	dotSize,
	className
}: ActivityStatusProps) => {
	const { t } = useTranslation()

	return (
		<Badge
			uppercase={uppercase}
			prefix={prefix}
			dotSize={dotSize}
			variant={status ? 'success' : 'muted'}
			className={cn(!uppercase && 'px-2.5 font-bold tracking-wide', className)}>
			{status ? t('Active') : t('Expired')}
		</Badge>
	)
}
